import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TIndirectTaxTransactionFilterAllowedOptionsResponse } from './types';

export function useIndirectTaxTransactionFilterOptions(
  corporationId: number
) {
  const { data, error, isLoading, mutate } =
    useSWR<TIndirectTaxTransactionFilterAllowedOptionsResponse>(
      corporationId
        ? `new-sales-tax/transactions/filters/allowed-options?corporationId=${corporationId}`
        : null,
      SWRFetcher({ method: 'GET' }, undefined),
      { revalidateOnFocus: false }
    );

  const defaultData: TIndirectTaxTransactionFilterAllowedOptionsResponse = {
    data: {
      source_platforms: [],
      jurisdictions: [],
      countries: [],
      marketplaces: [],
      origin_countries: [],
      origin_jurisdictions: [],
    },
    message: '',
  };

  return {
    data: data || defaultData,
    error,
    mutate,
    isLoading,
  };
}
